module.exports = __webpack_public_path__ + "static/media/IMG_20161024_211626.ceab6eb2.jpg";